import React from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import "./Filter.css";

const FiltersHeaderComponent = ({
  globalFilterValue,
  onGlobalFilterChange,
  clearFilter,
  onOpenDialog,
}) => {
  return (
    <div className="flex justify-content-between align-items-center">
      <div className="flex search-container">
        <IconField iconPosition="right" className="search-field">
          <InputIcon className="pi pi-search" />
          <InputText
            value={globalFilterValue}
            onChange={onGlobalFilterChange}
            placeholder="Search filters..."
            className="search-input"
            style={{ fontFamily: "poppins" }}
          />
        </IconField>
        {globalFilterValue && (
          <Button
            type="button"
            icon="pi pi-filter-slash"
            label="Clear"
            outlined
            onClick={clearFilter}
            className="clear-button"
            style={{
              backgroundColor: "#D97A07",
              border: "none",
              color: "#fff",
              marginLeft: "10px",
              fontFamily: "poppins",
            }}
          />
        )}
      </div>
      <Button
        label="Add"
        icon="pi pi-plus"
        onClick={() => onOpenDialog()}
        style={{
          backgroundColor: "#D97A07",
          borderColor: "#D97A07",
          marginLeft: "10px",
          fontFamily: "poppins",
        }}
      />
    </div>
  );
};

export default FiltersHeaderComponent;
